import React, { useState, useEffect } from 'react';
import apiService from '../services/api';

function TrainerPortal({ onBackToHome, onLogout, isLoggedIn }) {
  console.log('=== TRAINER PORTAL COMPONENT RENDERED ===');
  console.log('Props:', { onBackToHome, onLogout, isLoggedIn });
  console.log('localStorage trainerId:', localStorage.getItem('trainerId'));
  console.log('localStorage username:', localStorage.getItem('username'));
  console.log('API Service available:', !!apiService);
  console.log('API Service methods:', Object.keys(apiService));
  
  const [activeTab, setActiveTab] = useState('profile');
  const [trainerProfile, setTrainerProfile] = useState(null);
  const [activeTrainingRequests, setActiveTrainingRequests] = useState([]);
  const [sessionHistory, setSessionHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [editingProfile, setEditingProfile] = useState(false);
  const [editFormData, setEditFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    address: '',
    business_name: '',
    time_zone: '',
    business_street: '',
    business_apt: '',
    business_city: '',
    business_state: '',
    business_zip: '',
    business_address: '',
    credentials: [],
    training_philosophy: [],
    areas_of_expertise: [],
    specialties: [],
    experience_years: '',
    year_began_training: '',
    first_10_min_rate: '',
    per_minute_rate: '',
    bio: '',
    legal_states: [],
    current_rating: 0.0
  });
  const [acceptingRequests, setAcceptingRequests] = useState(false);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [trainerRequests, setTrainerRequests] = useState([]);
  const [requestsLoading, setRequestsLoading] = useState(false);
  const [deliverablesForms, setDeliverablesForms] = useState({}); // Track which requests have deliverables forms open
  const [deliverablesData, setDeliverablesData] = useState({}); // Store deliverables data for each request
  const [savingDeliverables, setSavingDeliverables] = useState({});
  const [uploadingPhoto, setUploadingPhoto] = useState(false); // Track saving state per request
  const [selectedDeliverablesRequest, setSelectedDeliverablesRequest] = useState(null); // Track which request has deliverables modal open

  // Credential options
  const credentialOptions = [
    'Formal degree',
    'Professional Dog Trainer School',
    'International Association of Canine Professionals',
    'Prong Collar Assessment',
    'CDT',
    'CDTA',
    'Certification Council of Canine Dog Trainers',
    'CPDT-KA',
    'CPDT-KSA',
    'CBCC-KA',
    'CBCC-KSA',
    'NADOI – Certified Member',
    'Puppy',
    'Novice Competition',
    'Open Competition',
    'Utility Competition',
    'Tracking',
    'Tracking Excellent',
    'Agility',
    'Agility Excellent',
    'Karen Prior Academy',
    'CDT',
    'Association of Animal Behavior Professionals',
    'CDBT',
    'Certified Fear Free',
    'Stephan Lynsay LIMA',
    'Grisha Stewart CBATI',
    'AKC Judge',
    'Fetch',
    'Farm Dog',
    'Obedience',
    'Rally',
    'Scentwork',
    'Herding',
    'Agility',
    'AKC Canine Good Citizen Evaluator',
    'Canine Fitness Instructor',
    'CCFT – list affiliation',
    'Do More With Your Dogs',
    'CRDI',
    'CCFC',
    'SDJ',
    'AACE',
    'Other sport judge',
    'Breed expert'
  ];

  // Training Philosophy options
  const trainingPhilosophyOptions = [
    'Force Free / Pure Positive',
    'Positive Reinforcement Based (+R)',
    'Clicker / Marker Training',
    'Fear Free',
    'Science Based',
    'Relationship Based',
    'Balanced',
    'LIMA (Least Intrusive, Minimally Aversive)',
    'Traditional Training Methods',
    'Alpha / Pack Based',
    'Remote Training'
  ];

  // Areas of Expertise options
  const areasOfExpertiseOptions = [
    'Puppy',
    'Manners',
    'Behavior Modification',
    'Aggression Management – Dog to dog',
    'Aggression Management - human directed',
    'Reactivity',
    'Separation Anxiety',
    'Anxiety / Fears / Phobias',
    'Leash Walking',
    'Potty Training',
    'Rescue Rehab',
    'Service Dog',
    'Therapy Dog',
    'Protection',
    'Tracking',
    'Competition Obedience',
    'Scentwork',
    'Agility',
    'Conformation',
    'Herding',
    'Earthdog'
  ];

  // Time zone options
  const timeZoneOptions = [
    'Pacific Time (PT)',
    'Mountain Time (MT)',
    'Central Time (CT)',
    'Eastern Time (ET)',
    'Alaska Time (AKT)',
    'Hawaii Time (HST)'
  ];

  // US States options
  const stateOptions = [
    { value: 'AL', label: 'Alabama (AL)' },
    { value: 'AK', label: 'Alaska (AK)' },
    { value: 'AZ', label: 'Arizona (AZ)' },
    { value: 'AR', label: 'Arkansas (AR)' },
    { value: 'CA', label: 'California (CA)' },
    { value: 'CO', label: 'Colorado (CO)' },
    { value: 'CT', label: 'Connecticut (CT)' },
    { value: 'DE', label: 'Delaware (DE)' },
    { value: 'FL', label: 'Florida (FL)' },
    { value: 'GA', label: 'Georgia (GA)' },
    { value: 'HI', label: 'Hawaii (HI)' },
    { value: 'ID', label: 'Idaho (ID)' },
    { value: 'IL', label: 'Illinois (IL)' },
    { value: 'IN', label: 'Indiana (IN)' },
    { value: 'IA', label: 'Iowa (IA)' },
    { value: 'KS', label: 'Kansas (KS)' },
    { value: 'KY', label: 'Kentucky (KY)' },
    { value: 'LA', label: 'Louisiana (LA)' },
    { value: 'ME', label: 'Maine (ME)' },
    { value: 'MD', label: 'Maryland (MD)' },
    { value: 'MA', label: 'Massachusetts (MA)' },
    { value: 'MI', label: 'Michigan (MI)' },
    { value: 'MN', label: 'Minnesota (MN)' },
    { value: 'MS', label: 'Mississippi (MS)' },
    { value: 'MO', label: 'Missouri (MO)' },
    { value: 'MT', label: 'Montana (MT)' },
    { value: 'NE', label: 'Nebraska (NE)' },
    { value: 'NV', label: 'Nevada (NV)' },
    { value: 'NH', label: 'New Hampshire (NH)' },
    { value: 'NJ', label: 'New Jersey (NJ)' },
    { value: 'NM', label: 'New Mexico (NM)' },
    { value: 'NY', label: 'New York (NY)' },
    { value: 'NC', label: 'North Carolina (NC)' },
    { value: 'ND', label: 'North Dakota (ND)' },
    { value: 'OH', label: 'Ohio (OH)' },
    { value: 'OK', label: 'Oklahoma (OK)' },
    { value: 'OR', label: 'Oregon (OR)' },
    { value: 'PA', label: 'Pennsylvania (PA)' },
    { value: 'RI', label: 'Rhode Island (RI)' },
    { value: 'SC', label: 'South Carolina (SC)' },
    { value: 'SD', label: 'South Dakota (SD)' },
    { value: 'TN', label: 'Tennessee (TN)' },
    { value: 'TX', label: 'Texas (TX)' },
    { value: 'UT', label: 'Utah (UT)' },
    { value: 'VT', label: 'Vermont (VT)' },
    { value: 'VA', label: 'Virginia (VA)' },
    { value: 'WA', label: 'Washington (WA)' },
    { value: 'WV', label: 'West Virginia (WV)' },
    { value: 'WI', label: 'Wisconsin (WI)' },
    { value: 'WY', label: 'Wyoming (WY)' }
  ];

  // Load trainer data on component mount
  useEffect(() => {
    console.log('=== TRAINER PORTAL USEEFFECT TRIGGERED ===');
    console.log('Component mounted, calling loadInitialData...');
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    console.log('=== LOADING INITIAL DATA ===');
    console.log('Component mounted, starting data load...');
    await Promise.all([
      loadTrainerProfile(),
      loadActiveTrainingRequests(),
      loadSessionHistory()
    ]);
    console.log('=== INITIAL DATA LOAD COMPLETE ===');
  };

  const loadTrainerRequests = async () => {
    try {
      setRequestsLoading(true);
      const trainerId = localStorage.getItem('trainerId');
      console.log('Loading trainer requests for ID:', trainerId);
      
      if (trainerId) {
        const response = await apiService.getTrainerRequests(trainerId);
        console.log('Trainer requests response:', response);
        
        if (response.Code === 200) {
          const requests = response.requests || [];
          setTrainerRequests(requests);
          
          // Load deliverables for completed sessions
          for (const request of requests) {
            if (request.status === 'completed') {
              try {
                const deliverablesResponse = await apiService.getDeliverables(request.id);
                if (deliverablesResponse.Code === 200 && deliverablesResponse.data) {
                  setDeliverablesData(prev => ({
                    ...prev,
                    [request.id]: deliverablesResponse.data
                  }));
                }
              } catch (err) {
                console.log(`No deliverables found for request ${request.id}`);
              }
            }
          }
        } else {
          console.error('Failed to load trainer requests:', response.Message);
          setError(`Failed to load trainer requests: ${response.Message}`);
        }
      } else {
        console.error('No trainer ID found in localStorage');
        setError('No trainer ID found. Please complete your profile setup.');
      }
    } catch (err) {
      console.error('Error loading trainer requests:', err);
      setError('Failed to load trainer requests');
    } finally {
      setRequestsLoading(false);
    }
  };

  const handleSaveDeliverables = async (requestId, request) => {
    try {
      setSavingDeliverables(prev => ({ ...prev, [requestId]: true }));
      const trainerId = localStorage.getItem('trainerId');
      const formData = deliverablesData[requestId] || {};
      
      // Filter out empty checklist items and ensure it's an array
      const checklistItems = (formData.checklist_items || [])
        .filter(item => item && item.trim().length > 0)
        .map(item => item.trim());
      
      console.log('Saving deliverables:', {
        requestId,
        summary: formData.summary,
        checklist_items: checklistItems,
        checklist_items_count: checklistItems.length
      });
      
      const response = await apiService.createOrUpdateDeliverables({
        session_request_id: requestId,
        trainer_id: trainerId,
        summary: formData.summary || '',
        checklist_items: checklistItems
      });
      
      if (response.Code === 200) {
        // Reload deliverables
        const deliverablesResponse = await apiService.getDeliverables(requestId);
        if (deliverablesResponse.Code === 200 && deliverablesResponse.data) {
          setDeliverablesData(prev => ({
            ...prev,
            [requestId]: deliverablesResponse.data
          }));
        }
        // Close form
        setDeliverablesForms(prev => ({ ...prev, [requestId]: false }));
        alert('Deliverables saved successfully!');
      } else {
        alert(`Failed to save deliverables: ${response.Message}`);
      }
    } catch (err) {
      console.error('Error saving deliverables:', err);
      alert('Failed to save deliverables');
    } finally {
      setSavingDeliverables(prev => ({ ...prev, [requestId]: false }));
    }
  };

  const handleDeliverablesInputChange = (requestId, field, value) => {
    setDeliverablesData(prev => ({
      ...prev,
      [requestId]: {
        ...prev[requestId],
        [field]: value
      }
    }));
  };

  const handleAddChecklistItem = (requestId) => {
    setDeliverablesData(prev => ({
      ...prev,
      [requestId]: {
        ...prev[requestId],
        checklist_items: [...(prev[requestId]?.checklist_items || []), '']
      }
    }));
  };

  const handleRemoveChecklistItem = (requestId, index) => {
    setDeliverablesData(prev => {
      const items = [...(prev[requestId]?.checklist_items || [])];
      items.splice(index, 1);
      return {
        ...prev,
        [requestId]: {
          ...prev[requestId],
          checklist_items: items
        }
      };
    });
  };

  const handleChecklistItemChange = (requestId, index, value) => {
    setDeliverablesData(prev => {
      const items = [...(prev[requestId]?.checklist_items || [])];
      items[index] = value;
      return {
        ...prev,
        [requestId]: {
          ...prev[requestId],
          checklist_items: items
        }
      };
    });
  };

  const loadTrainerProfile = async () => {
    try {
      setLoading(true);
      const trainerId = localStorage.getItem('trainerId');
      console.log('=== LOADING TRAINER PROFILE ===');
      console.log('Loading trainer profile for ID:', trainerId);
      console.log('localStorage contents:', localStorage);
      
      if (trainerId) {
        const response = await apiService.getTrainerProfile(trainerId);
        console.log('Trainer profile response:', response);
        
        if (response.Code === 200) {
          console.log('Setting trainer profile data:', response.data);
          setTrainerProfile(response.data);
          
          // Parse business_address to extract individual fields
          const parseBusinessAddress = (address) => {
            if (!address) return { street: '', apt: '', city: '', state: '', zip: '' };
            
            // Try to parse the address - handle common formats
            const parts = address.split(',').map(p => p.trim());
            
            if (parts.length >= 3) {
              // Format: "123 Main St, Apt 4B, City, State ZIP"
              // This is a simple parser - you might need to adjust based on actual data format
              return {
                street: parts[0] || '',
                apt: parts[1]?.includes('Apt') || parts[1]?.includes('Ste') || parts[1]?.includes('Unit') ? parts[1] : '',
                city: parts[parts.length - 2] || '',
                state: parts[parts.length - 1]?.match(/^([A-Z]{2})\s*(\d{5})$/)?.[1] || '',
                zip: parts[parts.length - 1]?.match(/^([A-Z]{2})\s*(\d{5})$/)?.[2] || ''
              };
            }
            
            return { street: '', apt: '', city: '', state: '', zip: '' };
          };
          
          const businessAddressParts = parseBusinessAddress(response.data.business_address);

          const newEditFormData = {
            first_name: response.data.first_name || '',
            last_name: response.data.last_name || '',
            email: response.data.email || '',
            phone_number: response.data.phone_number || '',
            address: response.data.address || '',
            business_name: response.data.business_name || '',
            time_zone: response.data.time_zone || '',
            business_street: businessAddressParts.street,
            business_apt: businessAddressParts.apt,
            business_city: businessAddressParts.city,
            business_state: businessAddressParts.state,
            business_zip: businessAddressParts.zip,
            business_address: response.data.business_address || '',
            credentials: Array.isArray(response.data.credentials) ? response.data.credentials : 
                          response.data.credentials ? response.data.credentials.split(',').map(c => c.trim()) : [],
            training_philosophy: Array.isArray(response.data.training_philosophy) ? response.data.training_philosophy :
                               response.data.training_philosophy ? response.data.training_philosophy.split(',').map(p => p.trim()) : [],
            areas_of_expertise: Array.isArray(response.data.areas_of_expertise) ? response.data.areas_of_expertise :
                               response.data.areas_of_expertise ? response.data.areas_of_expertise.split(',').map(a => a.trim()) : [],
            specialties: response.data.specialties ? response.data.specialties.split(', ').filter(s => s.trim()) : [],
            experience_years: response.data.experience_years || '',
            year_began_training: response.data.year_began_training || '',
            first_10_min_rate: response.data.first_10_min_rate || '',
            per_minute_rate: response.data.per_minute_rate || '',
            bio: response.data.bio || '',
            legal_states: Array.isArray(response.data.legal_states) ? response.data.legal_states :
                        response.data.legal_states ? response.data.legal_states.split(',').map(s => s.trim()) : [],
            current_rating: response.data.current_rating || 0.0
          };
          
          console.log('Setting editFormData with:', newEditFormData);
          setEditFormData(newEditFormData);
          console.log('Backend response data:', response.data);
          console.log('Final editFormData:', newEditFormData);
        } else {
          console.error('Trainer profile not found:', response.Message);
          setError(`Failed to load trainer profile: ${response.Message}`);
        }
      } else {
        console.error('No trainer ID found in localStorage');
        setError('No trainer ID found. Please complete your profile setup.');
      }
    } catch (err) {
      console.error('Error loading trainer profile:', err);
      setError('Failed to load trainer profile');
    } finally {
      setLoading(false);
    }
  };

  const loadActiveTrainingRequests = async () => {
    try {
      console.log('=== LOADING ACTIVE TRAINING REQUESTS ===');
      // Use the existing loadTrainerRequests function which calls the API
      await loadTrainerRequests();
    } catch (err) {
      console.error('Error loading active training requests:', err);
    }
  };

  const loadSessionHistory = async () => {
    try {
      const trainerId = localStorage.getItem('trainerId');
      if (trainerId) {
        // Load all trainer requests and filter for completed ones
        const response = await apiService.getTrainerRequests(trainerId);
        if (response.Code === 200) {
          const allRequests = response.requests || [];
          // Filter for completed sessions only
          const completedRequests = allRequests.filter(req => req.status === 'completed');
          setSessionHistory(completedRequests);
          
          // Load deliverables for completed sessions
          for (const request of completedRequests) {
            try {
              const deliverablesResponse = await apiService.getDeliverables(request.id);
              if (deliverablesResponse.Code === 200 && deliverablesResponse.data) {
                setDeliverablesData(prev => ({
                  ...prev,
                  [request.id]: deliverablesResponse.data
                }));
              }
            } catch (err) {
              console.log(`No deliverables found for request ${request.id}`);
            }
          }
        } else {
          setSessionHistory([]);
        }
      }
    } catch (err) {
      console.error('Error loading session history:', err);
      setSessionHistory([]);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === 'requests') {
      loadActiveTrainingRequests();
    } else if (tab === 'history') {
      loadSessionHistory();
    }
  };

  const handleEditProfile = () => {
    console.log('=== EDIT PROFILE CLICKED ===');
    console.log('Current trainerProfile:', trainerProfile);
    console.log('Current editFormData:', editFormData);
    setEditingProfile(true);
  };

  const handleSaveProfile = async () => {
    try {
      setLoading(true);
      const trainerId = localStorage.getItem('trainerId');
      console.log('Updating trainer profile for ID:', trainerId);
      console.log('Update data:', editFormData);
      
      // Construct the full business address from individual fields
      let fullBusinessAddress = editFormData.business_street;
      if (editFormData.business_apt) {
        fullBusinessAddress += ', ' + editFormData.business_apt;
      }
      if (editFormData.business_city) {
        fullBusinessAddress += ', ' + editFormData.business_city;
      }
      if (editFormData.business_state) {
        fullBusinessAddress += ', ' + editFormData.business_state;
      }
      if (editFormData.business_zip) {
        fullBusinessAddress += ' ' + editFormData.business_zip;
      }
      
      // Prepare the data for the API call
      const updateData = {
        first_name: editFormData.first_name,
        last_name: editFormData.last_name,
        phone_number: editFormData.phone_number,
        business_name: editFormData.business_name,
        time_zone: editFormData.time_zone,
        business_address: fullBusinessAddress,
        credentials: editFormData.credentials,
        training_philosophy: editFormData.training_philosophy,
        areas_of_expertise: editFormData.areas_of_expertise,
        experience_years: editFormData.experience_years,
        year_began_training: editFormData.year_began_training,
        first_10_min_rate: parseFloat(parseFloat(editFormData.first_10_min_rate || 0).toFixed(2)),
        per_minute_rate: parseFloat(parseFloat(editFormData.per_minute_rate || 0).toFixed(2)),
        bio: editFormData.bio,
        legal_states: editFormData.legal_states
      };
      
      console.log('Sending update data:', updateData);
      
      const response = await apiService.updateTrainerProfile(trainerId, updateData);
      console.log('Update response:', response);
      
      if (response.Code === 200) {
        // Update the displayed profile with the new data
        setTrainerProfile({ 
          ...trainerProfile, 
          ...editFormData
        });
        setEditingProfile(false);
        setError(null);
      } else {
        console.error('Update failed:', response.Message);
        setError(response.Message || 'Failed to update profile');
      }
    } catch (err) {
      console.error('Error updating profile:', err);
      setError('Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      setError('Please select an image file');
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      setError('Image size must be less than 10MB');
      return;
    }

    const trainerId = localStorage.getItem('trainerId');
    if (!trainerId) {
      setError('Trainer ID not found');
      return;
    }

    try {
      setUploadingPhoto(true);
      setError(null);

      const response = await apiService.uploadTrainerProfilePhoto(trainerId, file);
      
      if (response.Code === 200) {
        // Reload profile to get updated photo URL
        await loadTrainerProfile();
        alert('Profile photo uploaded successfully!');
      } else {
        setError(response.Message || 'Failed to upload photo');
      }
    } catch (err) {
      console.error('Photo upload error:', err);
      setError(err.message || 'Failed to upload photo');
    } finally {
      setUploadingPhoto(false);
      // Reset file input
      e.target.value = '';
    }
  };

  const handleCancelEdit = () => {
    setEditingProfile(false);
    
    // Re-parse the data from the current profile
    if (trainerProfile) {
      const addressParts = trainerProfile.address ? trainerProfile.address.split(', ') : ['', '', ''];
      const streetAddress = addressParts[0] || '';
      const stateZip = addressParts[1] || '';
      const stateZipParts = stateZip.split(' ');
      const state = stateZipParts[0] || '';
      const zipCode = stateZipParts[1] || '';
      
      const specialtiesArray = trainerProfile.specialties ? 
        trainerProfile.specialties.split(', ').filter(s => s.trim()) : [];
      
      setEditFormData({
        first_name: trainerProfile.first_name || '',
        last_name: trainerProfile.last_name || '',
        email: trainerProfile.email || '',
        phone_number: trainerProfile.phone_number || '',
        address: streetAddress,
        state: state,
        zip_code: zipCode,
        specialties: specialtiesArray,
        experience_years: trainerProfile.experience_years || '',
        hourly_rate: trainerProfile.hourly_rate || '',
        bio: trainerProfile.bio || '',
        business_name: trainerProfile.business_name || '',
        time_zone: trainerProfile.time_zone || '',
        business_address: trainerProfile.business_address || '',
        credentials: trainerProfile.credentials || [],
        training_philosophy: trainerProfile.training_philosophy || [],
        areas_of_expertise: trainerProfile.areas_of_expertise || [],
        year_began_training: trainerProfile.year_began_training || '',
        first_10_min_rate: trainerProfile.first_10_min_rate || '',
        per_minute_rate: trainerProfile.per_minute_rate || '',
        legal_states: trainerProfile.legal_states || [],
        current_rating: trainerProfile.current_rating || 0.0
      });
    }
  };

  const handleInputChange = (field, value) => {
    setEditFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSpecialtyToggle = (specialty) => {
    setEditFormData(prev => ({
      ...prev,
      specialties: prev.specialties.includes(specialty)
        ? prev.specialties.filter(s => s !== specialty)
        : [...prev.specialties, specialty]
    }));
  };

  const handleCredentialToggle = (credential) => {
    setEditFormData(prev => ({
      ...prev,
      credentials: prev.credentials.includes(credential)
        ? prev.credentials.filter(c => c !== credential)
        : [...prev.credentials, credential]
    }));
  };

  const handleTrainingPhilosophyToggle = (philosophy) => {
    setEditFormData(prev => ({
      ...prev,
      training_philosophy: prev.training_philosophy.includes(philosophy)
        ? prev.training_philosophy.filter(p => p !== philosophy)
        : [...prev.training_philosophy, philosophy]
    }));
  };

  const handleAreaOfExpertiseToggle = (area) => {
    setEditFormData(prev => ({
      ...prev,
      areas_of_expertise: prev.areas_of_expertise.includes(area)
        ? prev.areas_of_expertise.filter(a => a !== area)
        : [...prev.areas_of_expertise, area]
    }));
  };

  const handleAcceptSession = async (requestId) => {
    try {
      setLoading(true);
      const response = await apiService.acceptSession(requestId);
      
      if (response.Code === 200) {
        // Reload requests to show updated status
        await loadTrainerRequests();
        const statusMessage = response.status === 'awaiting_payment'
          ? `Session accepted. Waiting for client payment of $${Number(response.total_price || 0).toFixed(2)}.`
          : 'Session accepted. You can join the session when you are ready.';
        alert(statusMessage);
      } else {
        setError(response.Message || 'Failed to accept session');
      }
    } catch (err) {
      console.error('Error accepting session:', err);
      setError('Failed to accept session');
    } finally {
      setLoading(false);
    }
  };

  const handleJoinSession = (requestId) => {
    setLoading(true);
    apiService.registerSessionJoin(requestId, 'trainer')
      .then((response) => {
        if (response.Code === 200) {
          window.location.href = `/video-call?request_id=${requestId}`;
        } else {
          setError(response.Message || 'Failed to join session');
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error('Error registering trainer join:', err);
        setError('Failed to join session');
        setLoading(false);
      });
  };

  const handleAcceptingRequestsToggle = async () => {
    try {
      setToggleLoading(true);
      const trainerId = localStorage.getItem('trainerId');
      
      if (!trainerId) {
        setError('No trainer ID found');
        return;
      }

      if (acceptingRequests) {
        // Currently accepting, so make inactive
        console.log('Making trainer inactive...');
        const response = await apiService.makeTrainerInactive(trainerId);
        console.log('Make inactive response:', response);
        
        if (response.Code === 200) {
          setAcceptingRequests(false);
          setError(null);
        } else {
          setError(response.Message || 'Failed to make trainer inactive');
        }
      } else {
        // Currently not accepting, so make active
        console.log('Making trainer active...');
        const response = await apiService.makeTrainerActive(trainerId);
        console.log('Make active response:', response);
        
        if (response.Code === 200) {
          setAcceptingRequests(true);
          setError(null);
          // Load trainer requests when becoming active
          await loadTrainerRequests();
        } else {
          setError(response.Message || 'Failed to make trainer active');
        }
      }
    } catch (err) {
      console.error('Error toggling trainer status:', err);
      setError('Failed to update trainer status');
    } finally {
      setToggleLoading(false);
    }
  };

  const renderProfileTab = () => (
    <div>
      <div style={styles.tabHeader}>
        <h2 style={styles.tabTitle}>My Profile</h2>
        {!editingProfile && (
          <button
            onClick={handleEditProfile}
            style={styles.editButton}
          >
            Edit Profile
          </button>
        )}
      </div>

      {!trainerProfile || !trainerProfile.first_name ? (
        <div style={styles.profileCard}>
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '2rem', marginBottom: '20px' }}>⏳</div>
            <p style={{ color: '#6c757d', fontSize: '1.1rem' }}>Loading profile data...</p>
          </div>
        </div>
      ) : (
        <div style={styles.profileCard}>
          {console.log('Rendering profile with data:', trainerProfile)}
          {editingProfile ? (
            <div style={styles.editForm}>
              <h2 style={styles.tabTitle}>Edit Profile Information</h2>
              
              {/* Profile Photo Upload Section */}
              <div style={styles.section}>
                <h3 style={styles.sectionTitle}>Profile Photo</h3>
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  {trainerProfile.profile_photo_url ? (
                    <img
                      src={trainerProfile.profile_photo_url}
                      alt="Profile"
                      style={{
                        width: '120px',
                        height: '120px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '3px solid #e67e22',
                        marginBottom: '15px'
                      }}
                    />
                  ) : (
                    <div style={{
                      width: '120px',
                      height: '120px',
                      borderRadius: '50%',
                      backgroundColor: '#334155',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '2.5rem',
                      color: '#64748b',
                      margin: '0 auto 15px',
                      border: '3px solid #475569'
                    }}>
                      👤
                    </div>
                  )}
                  <div>
                    <label style={{
                      display: 'inline-block',
                      padding: '8px 16px',
                      background: 'linear-gradient(45deg, #e67e22, #f39c12)',
                      color: 'white',
                      borderRadius: '6px',
                      cursor: uploadingPhoto ? 'not-allowed' : 'pointer',
                      fontSize: '0.9rem',
                      fontWeight: '500',
                      opacity: uploadingPhoto ? 0.6 : 1
                    }}>
                      {uploadingPhoto ? 'Uploading...' : '📷 Change Photo'}
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handlePhotoUpload}
                        disabled={uploadingPhoto}
                        style={{ display: 'none' }}
                      />
                    </label>
                  </div>
                </div>
              </div>

              {/* Basic Information Section */}
              <div style={styles.section}>
                <h3 style={styles.sectionTitle}>Basic Information</h3>
                <div style={styles.formRow}>
                  <div style={styles.formField}>
                    <label style={styles.label}>
                      First Name <span style={styles.required}>*</span>
                    </label>
                    <input
                      type="text"
                      value={editFormData.first_name}
                      onChange={(e) => handleInputChange('first_name', e.target.value)}
                      style={styles.input}
                      placeholder="Enter your first name"
                      required
                    />
                    {console.log('Rendering first_name input with value:', editFormData.first_name)}
                  </div>
                  <div style={styles.formField}>
                    <label style={styles.label}>
                      Last Name <span style={styles.required}>*</span>
                    </label>
                    <input
                      type="text"
                      value={editFormData.last_name}
                      onChange={(e) => handleInputChange('last_name', e.target.value)}
                      style={styles.input}
                      placeholder="Enter your last name"
                      required
                    />
                  </div>
                </div>

                <div style={styles.formField}>
                  <label style={styles.label}>
                    Email Address <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="email"
                    value={editFormData.email}
                    style={{
                      ...styles.input,
                      background: '#1e293b',
                      color: '#94a3b8',
                      cursor: 'not-allowed',
                      opacity: '0.7'
                    }}
                    readOnly
                    disabled
                  />
                </div>

                <div style={styles.formField}>
                  <label style={styles.label}>
                    Business Name (if applicable)
                  </label>
                  <input
                    type="text"
                    value={editFormData.business_name}
                    onChange={(e) => handleInputChange('business_name', e.target.value)}
                    style={styles.input}
                    placeholder="e.g., Pawsitive Training Solutions"
                  />
                </div>

                <div style={styles.formField}>
                  <label style={styles.label}>
                    Phone Number <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="tel"
                    value={editFormData.phone_number}
                    onChange={(e) => handleInputChange('phone_number', e.target.value)}
                    style={styles.input}
                    placeholder="(555) 123-4567"
                    required
                  />
                </div>

                <div style={styles.formField}>
                  <label style={styles.label}>
                    Time Zone <span style={styles.required}>*</span>
                  </label>
                  <select
                    value={editFormData.time_zone}
                    onChange={(e) => handleInputChange('time_zone', e.target.value)}
                    style={styles.select}
                    required
                  >
                    <option value="" style={styles.option}>Select your time zone...</option>
                    {timeZoneOptions.map(zone => (
                      <option key={zone} value={zone} style={styles.option}>
                        {zone}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={styles.formField}>
                  <label style={styles.label}>
                    Business Address / Mailing Address <span style={styles.required}>*</span>
                  </label>
                </div>
                <div style={styles.formField}>
                  <label style={styles.sublabel}>Street Address <span style={styles.required}>*</span></label>
                  <input
                    type="text"
                    value={editFormData.business_street}
                    onChange={(e) => handleInputChange('business_street', e.target.value)}
                    style={styles.input}
                    placeholder="123 Main Street"
                    required
                  />
                </div>
                <div style={styles.formField}>
                  <label style={styles.sublabel}>Apt, Ste, etc.</label>
                  <input
                    type="text"
                    value={editFormData.business_apt}
                    onChange={(e) => handleInputChange('business_apt', e.target.value)}
                    style={styles.input}
                    placeholder="Apt 4B"
                  />
                </div>
                <div style={styles.fieldRow}>
                  <div style={{...styles.formField, flex: 2}}>
                    <label style={styles.sublabel}>City <span style={styles.required}>*</span></label>
                    <input
                      type="text"
                      value={editFormData.business_city}
                      onChange={(e) => handleInputChange('business_city', e.target.value)}
                      style={styles.input}
                      placeholder="City"
                      required
                    />
                  </div>
                  <div style={{...styles.formField, flex: 1, marginRight: '10px'}}>
                    <label style={styles.sublabel}>State <span style={styles.required}>*</span></label>
                    <input
                      type="text"
                      value={editFormData.business_state}
                      onChange={(e) => handleInputChange('business_state', e.target.value)}
                      style={styles.input}
                      placeholder="State"
                      required
                    />
                  </div>
                  <div style={{...styles.formField, flex: 1}}>
                    <label style={styles.sublabel}>ZIP Code <span style={styles.required}>*</span></label>
                    <input
                      type="text"
                      value={editFormData.business_zip}
                      onChange={(e) => handleInputChange('business_zip', e.target.value)}
                      style={styles.input}
                      placeholder="ZIP"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Credentials & Philosophy Section */}
              <div style={styles.section}>
                <h3 style={styles.sectionTitle}>Credentials & Training Philosophy</h3>
                
                <div style={{...styles.formField, marginBottom: '32px'}}>
                  <label style={styles.label}>Credentials</label>
                  <div style={styles.specialtiesContainer}>
                    <div style={styles.specialtiesGrid}>
                      {credentialOptions.map(cred => (
                        <div
                          key={cred}
                          onClick={() => handleCredentialToggle(cred)}
                          style={{
                            ...styles.specialtyChip,
                            ...(editFormData.credentials.includes(cred) ? styles.specialtyChipSelected : {})
                          }}
                        >
                          {cred}
                          {editFormData.credentials.includes(cred) && (
                            <span style={styles.checkmark}>✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div style={{...styles.formField, marginBottom: '32px'}}>
                  <label style={styles.label}>Training Philosophy</label>
                  <div style={styles.specialtiesContainer}>
                    <div style={styles.specialtiesGrid}>
                      {trainingPhilosophyOptions.map(phil => (
                        <div
                          key={phil}
                          onClick={() => handleTrainingPhilosophyToggle(phil)}
                          style={{
                            ...styles.specialtyChip,
                            ...(editFormData.training_philosophy.includes(phil) ? styles.specialtyChipSelected : {})
                          }}
                        >
                          {phil}
                          {editFormData.training_philosophy.includes(phil) && (
                            <span style={styles.checkmark}>✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div style={styles.formField}>
                  <label style={styles.label}>Areas of Expertise</label>
                  <div style={styles.specialtiesContainer}>
                    <div style={styles.specialtiesGrid}>
                      {areasOfExpertiseOptions.map(area => (
                        <div
                          key={area}
                          onClick={() => handleAreaOfExpertiseToggle(area)}
                          style={{
                            ...styles.specialtyChip,
                            ...(editFormData.areas_of_expertise.includes(area) ? styles.specialtyChipSelected : {})
                          }}
                        >
                          {area}
                          {editFormData.areas_of_expertise.includes(area) && (
                            <span style={styles.checkmark}>✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Rate & Experience Section */}
              <div style={styles.section}>
                <h3 style={styles.sectionTitle}>Experience & Rates</h3>
                <div style={styles.formRow}>
                  <div style={styles.formField}>
                    <label style={styles.label}>
                      Years of Experience <span style={styles.required}>*</span>
                    </label>
                    <input
                      type="number"
                      value={editFormData.experience_years}
                      onChange={(e) => handleInputChange('experience_years', e.target.value)}
                      style={styles.input}
                      min="0"
                      max="50"
                      placeholder="5"
                      required
                    />
                  </div>
                  <div style={styles.formField}>
                    <label style={styles.label}>
                      Year Began Training
                    </label>
                    <input
                      type="number"
                      value={editFormData.year_began_training}
                      onChange={(e) => handleInputChange('year_began_training', e.target.value)}
                      style={styles.input}
                      placeholder="2015"
                    />
                  </div>
                </div>

                <div style={styles.formRow}>
                  <div style={styles.formField}>
                    <label style={styles.label}>
                      First 10 Minutes Rate ($) <span style={styles.required}>*</span>
                      <span style={{ fontSize: '0.85rem', color: '#94a3b8', marginLeft: '8px' }}>(Minimum: $10.00)</span>
                    </label>
                    <input
                      type="text"
                      value={editFormData.first_10_min_rate}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow empty string, numbers, and one decimal point
                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                          handleInputChange('first_10_min_rate', value);
                        }
                      }}
                      onBlur={(e) => {
                        // Validate and format on blur
                        const value = e.target.value.trim();
                        if (value === '') {
                          handleInputChange('first_10_min_rate', '');
                          return;
                        }
                        const numValue = parseFloat(value);
                        if (!isNaN(numValue)) {
                          // Enforce minimum of 10.00
                          const validatedValue = Math.max(10.00, numValue);
                          const formatted = parseFloat(validatedValue.toFixed(2));
                          handleInputChange('first_10_min_rate', formatted.toString());
                        }
                      }}
                      style={styles.input}
                      placeholder="15.00"
                      required
                    />
                    {editFormData.first_10_min_rate && parseFloat(editFormData.first_10_min_rate) < 10 && (
                      <div style={{ color: '#ef4444', fontSize: '0.85rem', marginTop: '4px' }}>
                        Minimum rate is $10.00
                      </div>
                    )}
                  </div>
                  <div style={styles.formField}>
                    <label style={styles.label}>
                      Per Minute Rate ($) <span style={styles.required}>*</span>
                      <span style={{ fontSize: '0.85rem', color: '#94a3b8', marginLeft: '8px' }}>(Minimum: $1.00)</span>
                    </label>
                    <input
                      type="text"
                      value={editFormData.per_minute_rate}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow empty string, numbers, and one decimal point
                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                          handleInputChange('per_minute_rate', value);
                        }
                      }}
                      onBlur={(e) => {
                        // Validate and format on blur
                        const value = e.target.value.trim();
                        if (value === '') {
                          handleInputChange('per_minute_rate', '');
                          return;
                        }
                        const numValue = parseFloat(value);
                        if (!isNaN(numValue)) {
                          // Enforce minimum of 1.00
                          const validatedValue = Math.max(1.00, numValue);
                          const formatted = parseFloat(validatedValue.toFixed(2));
                          handleInputChange('per_minute_rate', formatted.toString());
                        }
                      }}
                      style={styles.input}
                      placeholder="1.00"
                      required
                    />
                    {editFormData.per_minute_rate && parseFloat(editFormData.per_minute_rate) < 1 && (
                      <div style={{ color: '#ef4444', fontSize: '0.85rem', marginTop: '4px' }}>
                        Minimum rate is $1.00 per minute
                      </div>
                    )}
                  </div>
                </div>
                
                <div style={styles.formField}>
                  <label style={styles.label}>Specialties</label>
                  <div style={styles.specialtiesContainer}>
                    <div style={styles.specialtiesGrid}>
                      {areasOfExpertiseOptions.map(specialty => (
                        <div
                          key={specialty}
                          onClick={() => handleSpecialtyToggle(specialty)}
                          style={{
                            ...styles.specialtyChip,
                            ...(editFormData.specialties.includes(specialty) ? styles.specialtyChipSelected : {})
                          }}
                        >
                          {specialty}
                          {editFormData.specialties.includes(specialty) && (
                            <span style={styles.checkmark}>✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                    {editFormData.specialties.length > 0 && (
                      <div style={styles.selectedSpecialties}>
                        <strong>Selected: </strong>
                        {editFormData.specialties.join(', ')}
                      </div>
                    )}
                  </div>
                </div>

                <div style={styles.formField}>
                  <label style={styles.label}>
                    Bio <span style={styles.required}>*</span>
                  </label>
                  <textarea
                    value={editFormData.bio}
                    onChange={(e) => handleInputChange('bio', e.target.value)}
                    style={styles.textarea}
                    placeholder="Tell clients about your training approach, certifications, experience, and what makes you special as a dog trainer..."
                    required
                  />
                </div>

                <div style={styles.pricingInfo}>
                  <div style={styles.pricingTitle}>💡 Pricing Information</div>
                  <div style={styles.pricingText}>
                    Your hourly rate will be displayed as: <strong>$15.00 first 10 minutes + ${editFormData.hourly_rate ? (editFormData.hourly_rate / 60).toFixed(2) : '0.00'}/min after</strong><br/>
                    This pricing structure encourages quick, focused sessions while providing fair compensation for longer training sessions.
                  </div>
                </div>
              </div>

              <div style={styles.editActions}>
                <button
                  onClick={handleSaveProfile}
                  style={styles.saveButton}
                  disabled={loading}
                >
                  {loading ? 'Saving...' : 'Save Changes'}
                </button>
                <button
                  onClick={handleCancelEdit}
                  style={styles.cancelButton}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div style={styles.profileInfo}>
              {/* Profile Photo Section */}
              <div style={{ marginBottom: '30px', textAlign: 'center' }}>
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  {trainerProfile.profile_photo_url ? (
                    <img
                      src={trainerProfile.profile_photo_url}
                      alt="Profile"
                      style={{
                        width: '150px',
                        height: '150px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '4px solid #e67e22',
                        marginBottom: '15px'
                      }}
                    />
                  ) : (
                    <div style={{
                      width: '150px',
                      height: '150px',
                      borderRadius: '50%',
                      backgroundColor: '#334155',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '3rem',
                      color: '#64748b',
                      margin: '0 auto 15px',
                      border: '4px solid #475569'
                    }}>
                      👤
                    </div>
                  )}
                  <div>
                    <label style={{
                      display: 'inline-block',
                      padding: '8px 16px',
                      background: 'linear-gradient(45deg, #e67e22, #f39c12)',
                      color: 'white',
                      borderRadius: '6px',
                      cursor: uploadingPhoto ? 'not-allowed' : 'pointer',
                      fontSize: '0.9rem',
                      fontWeight: '500',
                      opacity: uploadingPhoto ? 0.6 : 1
                    }}>
                      {uploadingPhoto ? 'Uploading...' : '📷 Upload Photo'}
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handlePhotoUpload}
                        disabled={uploadingPhoto}
                        style={{ display: 'none' }}
                      />
                    </label>
                  </div>
                </div>
              </div>

              <div style={styles.profileHeader}>
                <h3 style={styles.profileName}>
                  {trainerProfile.first_name} {trainerProfile.last_name}
                </h3>
                <div style={styles.profileStatus}>
                  <span style={styles.statusDot}></span>
                  Active Trainer
                </div>
                {trainerProfile.current_rating > 0 && (
                  <div style={styles.ratingDisplay}>
                    <span style={styles.ratingLabel}>Current Rating:</span>
                    <div style={styles.stars}>
                      {[1, 2, 3, 4, 5].map(star => (
                        <span
                          key={star}
                          style={{
                            ...styles.star,
                            color: star <= trainerProfile.current_rating ? '#f39c12' : '#ddd'
                          }}
                        >
                          ★
                        </span>
                      ))}
                      <span style={styles.ratingNumber}>
                        {trainerProfile.current_rating.toFixed(1)}
                      </span>
                    </div>
                  </div>
                )}
              </div>

              <div style={styles.profileDetails}>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Email:</span>
                  <span style={styles.detailValue}>{trainerProfile.email}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Phone:</span>
                  <span style={styles.detailValue}>{trainerProfile.phone_number}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Address:</span>
                  <span style={styles.detailValue}>{trainerProfile.address}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Specialties:</span>
                  <span style={styles.detailValue}>{trainerProfile.specialties}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Experience:</span>
                  <span style={styles.detailValue}>{trainerProfile.experience_years} years</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Hourly Rate:</span>
                  <span style={styles.detailValue}>${trainerProfile.hourly_rate}/hour</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Bio:</span>
                  <span style={styles.detailValue}>{trainerProfile.bio}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );

  const renderRequestsTab = () => (
    <div>
      <div style={styles.tabHeader}>
        <h2 style={styles.tabTitle}>Active Training Requests</h2>
        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          <button
            onClick={loadTrainerRequests}
            style={{
              ...styles.refreshButton,
              ...(requestsLoading ? styles.refreshButtonLoading : {})
            }}
            disabled={requestsLoading}
          >
            {requestsLoading ? 'Refreshing...' : '🔄 Refresh'}
          </button>
          <div style={styles.toggleContainer}>
          <label style={styles.toggleLabel}>
            <input
              type="checkbox"
              checked={acceptingRequests}
              onChange={handleAcceptingRequestsToggle}
              disabled={toggleLoading}
              style={styles.toggleInput}
            />
            <span style={{
              ...styles.toggleSlider,
              ...(acceptingRequests ? styles.toggleSliderActive : {}),
              ...(toggleLoading ? styles.toggleSliderDisabled : {})
            }}>
              <span style={{
                ...styles.toggleSliderThumb,
                transform: acceptingRequests ? 'translateX(30px)' : 'translateX(0)'
              }}></span>
            </span>
            <span style={styles.toggleText}>
              {toggleLoading ? 'Updating...' : acceptingRequests ? 'Accepting Requests' : 'Not Accepting Requests'}
            </span>
          </label>
        </div>
        </div>
      </div>
      <div style={styles.requestsContainer}>
        {acceptingRequests ? (
          // Show trainer requests table when accepting requests
          <div>
            <h3 style={styles.sectionTitle}>Session Requests</h3>
            {requestsLoading ? (
              <div style={styles.loading}>Loading requests...</div>
            ) : trainerRequests.length === 0 ? (
              <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>No Requests</div>
                <h3 style={styles.emptyTitle}>No Session Requests</h3>
                <p style={styles.emptyText}>
                  You don't have any session requests yet. Clients will be able to request sessions with you while you're accepting requests.
                </p>
              </div>
            ) : (
              <div style={styles.requestsGrid}>
                {trainerRequests.filter(req => req.status !== 'completed').map((request, index) => {
                  const statusLabelMap = {
                    pending: 'Awaiting Your Response',
                    awaiting_payment: 'Waiting for Client Payment',
                    accepted: 'Ready to Join',
                    active: 'In Progress',
                    declined: 'Declined',
                    cancelled: 'Cancelled'
                  };
                  const statusStyleMap = {
                    pending: styles.statusPending,
                    awaiting_payment: styles.statusPending,
                    accepted: styles.statusAccepted,
                    active: styles.statusAccepted,
                    declined: styles.statusDeclined,
                    cancelled: styles.statusCancelled
                  };
                  const statusStyle = statusStyleMap[request.status] || styles.statusDefault;
                  const statusLabel = statusLabelMap[request.status] || (request.status ? request.status.charAt(0).toUpperCase() + request.status.slice(1) : 'Unknown');

                  return (
                  <div key={request.id || index} style={styles.requestCard}>
                    {/* Request Number and Time */}
                    <div style={styles.requestHeader}>
                      <div style={styles.requestNumber}>#{index + 1}</div>
                      <div style={styles.requestTime}>
                        {new Date(request.requested_at).toLocaleDateString()}
                      </div>
                    </div>
                    
                    {/* Status Badge */}
                    <div style={styles.requestStatusBadge}>
                      <span style={{
                        ...styles.statusBadgeSmall,
                        ...statusStyle
                      }}>
                        {statusLabel}
                      </span>
                    </div>
                    
                    {/* Client Info */}
                    <div style={styles.requestInfo}>
                      <div style={styles.requestClient}>
                        <strong>{request.client_username || 'Unknown Client'}</strong>
                      </div>
                      
                      {/* Pet Info */}
                      <div style={styles.requestPet}>
                        <div style={styles.requestPetName}>{request.pet_name || 'Unknown Pet'}</div>
                        <div style={styles.requestPetDetails}>
                          {request.pet_breed && `${request.pet_breed}`}
                          {request.pet_age && ` • ${request.pet_age} years old`}
                        </div>
                      </div>
                      
                      {/* Explanation */}
                      <div style={styles.requestExplanation}>
                        {request.explanation || 'No explanation provided'}
                      </div>
                      {request.duration_minutes && (
                        <div style={styles.requestExplanation}>
                          <strong>Duration:</strong> {request.duration_minutes} minutes
                        </div>
                      )}
                      {request.total_price !== undefined && request.total_price !== null && (
                        <div style={styles.requestExplanation}>
                          <strong>Session Cost:</strong> ${Number(request.total_price || 0).toFixed(2)}
                        </div>
                      )}
                    </div>
                    
                    {/* Action Buttons */}
                    <div style={styles.requestActions}>
                      {request.status === 'pending' && (
                        <>
                          <button 
                            style={styles.acceptButtonSmall}
                            onClick={() => handleAcceptSession(request.id)}
                          >
                            Accept
                          </button>
                          <button 
                            style={styles.declineButtonSmall}
                            onClick={async () => {
                              try {
                                const response = await apiService.declineSession(request.id);
                                if (response.Code === 200) {
                                  await loadTrainerRequests();
                                }
                              } catch (err) {
                                console.error('Error declining session:', err);
                              }
                            }}
                          >
                            Decline
                          </button>
                        </>
                      )}
                      {(request.status === 'accepted' || request.status === 'active' || (request.status === 'awaiting_payment' && request.payment_status === 'completed')) && (
                        <button 
                          style={styles.joinButtonSmall}
                          onClick={() => handleJoinSession(request.id)}
                        >
                          {request.status === 'active' ? 'Rejoin Session' : 'Join Session'}
                        </button>
                      )}
                      {request.status === 'awaiting_payment' && request.payment_status !== 'completed' && (
                        <span style={styles.statusTextSmall}>Awaiting client payment</span>
                      )}
                      {request.status === 'declined' && (
                        <span style={styles.statusTextSmall}>Declined</span>
                      )}
                      {request.status === 'cancelled' && (
                        <span style={styles.statusTextSmall}>Cancelled</span>
                      )}
                    </div>
                  </div>
                );
                })}
              </div>
            )}
          </div>
        ) : (
          // Show message when not accepting requests
          <div style={styles.emptyState}>
            <div style={styles.emptyIcon}>🔒</div>
            <h3 style={styles.emptyTitle}>Not Accepting Requests</h3>
            <p style={styles.emptyText}>
              Turn on the "Accepting Requests" toggle above to start receiving session requests from clients.
            </p>
          </div>
        )}
      </div>
    </div>
  );

  const renderHistoryTab = () => (
    <div>
      <div style={styles.tabHeader}>
        <h2 style={styles.tabTitle}>Session History</h2>
        <button
          onClick={loadSessionHistory}
          disabled={loading}
          style={{
            ...styles.refreshButton,
            ...(loading ? styles.refreshButtonLoading : {})
          }}
        >
          🔄 Refresh
        </button>
      </div>
      <div style={styles.historyContainer}>
        {loading ? (
          <div style={styles.loading}>Loading session history...</div>
        ) : sessionHistory.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={styles.emptyIcon}>No History</div>
            <h3 style={styles.emptyTitle}>No Session History</h3>
            <p style={styles.emptyText}>
              Your completed training sessions will appear here.
            </p>
          </div>
        ) : (
          sessionHistory.map((request, index) => {
            const clientName = request.client_username || request.client_name || 'Unknown Client';
            const sessionDate = request.accepted_at || request.requested_at;
            const formattedDate = sessionDate ? new Date(sessionDate).toLocaleDateString() : 'N/A';
            const formattedTime = sessionDate ? new Date(sessionDate).toLocaleTimeString() : 'N/A';
            
            return (
              <div key={request.id || index} style={styles.historyCard}>
                <div style={styles.historyCardContent}>
                  <div style={styles.historyCardLeft}>
                    <div style={styles.historyCardTitle}>Session #{request.id?.slice(-8) || index}</div>
                    <div style={styles.historyCardDate}>{formattedDate}</div>
                  </div>
                  <div style={styles.historyCardInfoRow}>
                    <span style={styles.historyCardLabel}>Client: </span>
                    <span style={styles.historyCardValue}>{clientName}</span>
                    <span style={styles.historyCardSpacer}> | </span>
                    <span style={styles.historyCardLabel}>Duration: </span>
                    <span style={styles.historyCardValue}>{request.duration_minutes || 0} minutes</span>
                    <span style={styles.historyCardSpacer}> | </span>
                    <span style={styles.historyCardLabel}>Time: </span>
                    <span style={styles.historyCardValue}>{formattedTime}</span>
                    {request.pet_name && (
                      <>
                        <span style={styles.historyCardSpacer}> | </span>
                        <span style={styles.historyCardLabel}>Pet: </span>
                        <span style={styles.historyCardValue}>{request.pet_name}</span>
                      </>
                    )}
                    {request.total_price !== undefined && request.total_price !== null && (
                      <>
                        <span style={styles.historyCardSpacer}> | </span>
                        <span style={styles.historyCardLabel}>Price: </span>
                        <span style={styles.historyCardValue}>${Number(request.total_price || 0).toFixed(2)}</span>
                      </>
                    )}
                  </div>
                  <div style={styles.historyActions}>
                    <span style={styles.historyStatus}>Completed</span>
                    <button 
                      style={styles.deliverablesButton}
                      onClick={async () => {
                        setSelectedDeliverablesRequest(request);
                        // Load existing deliverables if not already loaded
                        if (!deliverablesData[request.id]) {
                          try {
                            const deliverablesResponse = await apiService.getDeliverables(request.id);
                            if (deliverablesResponse.Code === 200 && deliverablesResponse.data) {
                              setDeliverablesData(prev => ({
                                ...prev,
                                [request.id]: deliverablesResponse.data
                              }));
                            } else {
                              // Initialize empty form if no deliverables exist
                              setDeliverablesData(prev => ({
                                ...prev,
                                [request.id]: {
                                  summary: '',
                                  checklist_items: []
                                }
                              }));
                            }
                          } catch (err) {
                            console.error('Error loading deliverables:', err);
                            // Initialize empty form on error
                            setDeliverablesData(prev => ({
                              ...prev,
                              [request.id]: {
                                summary: '',
                                checklist_items: []
                              }
                            }));
                          }
                        }
                      }}
                    >
                      {deliverablesData[request.id] ? 'Edit Deliverables' : 'Add Deliverables'}
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
      
      {/* Deliverables Modal */}
      {selectedDeliverablesRequest && (
        <div style={styles.deliverablesModalOverlay} onClick={() => setSelectedDeliverablesRequest(null)}>
          <div style={styles.deliverablesModalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.deliverablesModalHeader}>
              <h2 style={styles.deliverablesModalTitle}>Session Deliverables</h2>
              <button style={styles.deliverablesModalCloseButton} onClick={() => setSelectedDeliverablesRequest(null)}>×</button>
            </div>
            
            <div style={styles.deliverablesModalBody}>
              <div style={styles.deliverablesFormField}>
                <label style={styles.deliverablesLabel}>
                  Summary <span style={styles.required}>*</span>
                </label>
                <textarea
                  style={styles.deliverablesTextareaScrollable}
                  value={deliverablesData[selectedDeliverablesRequest.id]?.summary || ''}
                  onChange={(e) => handleDeliverablesInputChange(selectedDeliverablesRequest.id, 'summary', e.target.value)}
                  placeholder="Enter a short summary of the main points covered in this session..."
                  rows={6}
                />
              </div>
              
              <div style={styles.deliverablesFormField}>
                <label style={styles.deliverablesLabel}>
                  Checklist Items
                </label>
                {(deliverablesData[selectedDeliverablesRequest.id]?.checklist_items || []).map((item, itemIndex) => (
                  <div key={itemIndex} style={styles.checklistItemRow}>
                    <textarea
                      style={styles.checklistItemTextarea}
                      value={item}
                      onChange={(e) => handleChecklistItemChange(selectedDeliverablesRequest.id, itemIndex, e.target.value)}
                      placeholder={`Checklist item ${itemIndex + 1}`}
                      rows={Math.max(2, Math.ceil(item.length / 50))}
                    />
                    <button
                      type="button"
                      style={styles.removeChecklistButton}
                      onClick={() => handleRemoveChecklistItem(selectedDeliverablesRequest.id, itemIndex)}
                    >
                      ×
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  style={styles.addChecklistButton}
                  onClick={() => handleAddChecklistItem(selectedDeliverablesRequest.id)}
                >
                  + Add Checklist Item
                </button>
              </div>
            </div>
            
            <div style={styles.deliverablesModalFooter}>
              <button
                style={styles.cancelDeliverablesButton}
                onClick={() => setSelectedDeliverablesRequest(null)}
              >
                Cancel
              </button>
              <button
                style={styles.saveDeliverablesButton}
                onClick={() => {
                  handleSaveDeliverables(selectedDeliverablesRequest.id, selectedDeliverablesRequest);
                  setSelectedDeliverablesRequest(null);
                }}
                disabled={savingDeliverables[selectedDeliverablesRequest.id] || !deliverablesData[selectedDeliverablesRequest.id]?.summary}
              >
                {savingDeliverables[selectedDeliverablesRequest.id] ? 'Saving...' : 'Save Deliverables'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const styles = {
    container: {
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      background: '#0f172a',
      minHeight: '100vh',
      color: '#f1f5f9'
    },
    header: {
      background: '#1e293b',
      color: '#f1f5f9',
      padding: '20px 0',
      boxShadow: '0 1px 0 rgba(0, 0, 0, 0.2)',
      borderBottom: '1px solid #334155'
    },
    headerContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    logo: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      cursor: 'pointer'
    },
    logoIcon: {
      width: '40px',
      height: '40px',
      background: '#3b82f6',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '1.2rem'
    },
    logoText: {
      fontSize: '1.5rem',
      fontWeight: 'bold'
    },
    backButton: {
      background: 'transparent',
      border: '1px solid #475569',
      color: '#cbd5e1',
      padding: '10px 20px',
      borderRadius: '8px',
      fontWeight: '500',
      cursor: 'pointer',
      fontSize: '1rem',
      transition: 'all 0.3s ease'
    },
    logoutButton: {
      background: 'transparent',
      border: '1px solid #475569',
      color: '#cbd5e1',
      padding: '10px 20px',
      borderRadius: '8px',
      fontWeight: '500',
      cursor: 'pointer',
      fontSize: '1rem',
      transition: 'all 0.3s ease'
    },
    mainContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '30px 20px'
    },
    topNavBar: {
      background: '#1e293b',
      borderBottom: '1px solid #334155',
      padding: '0 24px'
    },
    horizontalTabList: {
      display: 'flex',
      gap: '4px',
      paddingTop: '12px'
    },
    horizontalTabButton: {
      padding: '12px 20px',
      background: 'transparent',
      border: 'none',
      color: '#94a3b8',
      cursor: 'pointer',
      fontSize: '0.875rem',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      borderBottom: '2px solid transparent',
      transition: 'all 0.2s ease',
      borderRadius: '6px 6px 0 0',
      marginRight: '4px'
    },
    activeHorizontalTabButton: {
      color: '#ffffff',
      borderBottomColor: '#3b82f6',
      fontWeight: '600',
      background: 'rgba(59, 130, 246, 0.1)'
    },
    sidebar: {
      width: '250px',
      background: '#1e293b',
      borderRadius: '15px',
      padding: '20px',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
      border: '1px solid #334155',
      height: 'fit-content'
    },
    tabButton: {
      width: '100%',
      padding: '15px 20px',
      marginBottom: '10px',
      border: 'none',
      borderRadius: '10px',
      background: 'transparent',
      color: '#94a3b8',
      fontSize: '1rem',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    tabButtonActive: {
      background: '#334155',
      color: '#3b82f6',
      transform: 'translateX(5px)',
      fontWeight: '600'
    },
    contentArea: {
      flex: 1,
      background: '#1e293b',
      borderRadius: '15px',
      padding: '30px',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
      border: '1px solid #334155',
      minHeight: '600px'
    },
    tabHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '30px'
    },
    refreshButton: {
      padding: '8px 16px',
      background: '#334155',
      color: '#cbd5e1',
      border: '1px solid #475569',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '500',
      transition: 'all 0.3s ease'
    },
    refreshButtonLoading: {
      background: '#475569',
      cursor: 'wait',
      opacity: 0.7
    },
    tabTitle: {
      fontSize: '2rem',
      color: '#f1f5f9',
      margin: '0 0 20px 0'
    },
    editButton: {
      background: 'linear-gradient(45deg, #e67e22, #f39c12)',
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '1rem',
      fontWeight: '500',
      transition: 'all 0.3s ease'
    },
    profileCard: {
      background: '#334155',
      borderRadius: '10px',
      padding: '25px',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
      border: '1px solid #475569'
    },
    profileInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    profileHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: '20px',
      borderBottom: '2px solid rgba(255, 255, 255, 0.2)'
    },
    profileName: {
      fontSize: '1.8rem',
      color: 'white',
      margin: 0
    },
    profileStatus: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: 'white',
      fontWeight: '500'
    },
    ratingDisplay: {
      marginTop: '10px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    ratingLabel: {
      fontSize: '0.9rem',
      color: 'white',
      fontWeight: '500'
    },
    stars: {
      display: 'flex',
      alignItems: 'center',
      gap: '2px'
    },
    star: {
      fontSize: '1.2rem',
      transition: 'color 0.2s ease'
    },
    ratingNumber: {
      marginLeft: '8px',
      fontSize: '1rem',
      fontWeight: '600',
      color: '#2c3e50'
    },
    statusDot: {
      width: '10px',
      height: '10px',
      background: '#27ae60',
      borderRadius: '50%'
    },
    profileDetails: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    },
    detailRow: {
      display: 'flex',
      gap: '20px'
    },
    detailLabel: {
      fontWeight: '600',
      color: 'white',
      minWidth: '120px'
    },
    detailValue: {
      color: 'white',
      flex: 1
    },
    editForm: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    formRow: {
      display: 'flex',
      gap: '20px'
    },
    formField: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    fieldRow: {
      display: 'flex',
      gap: '12px',
      width: '100%'
    },
    sublabel: {
      fontSize: '0.875rem',
      color: '#cbd5e1',
      fontWeight: '500',
      marginBottom: '8px',
      display: 'block'
    },
    label: {
      fontWeight: '600',
      color: '#f1f5f9',
      fontSize: '0.9rem'
    },
    input: {
      padding: '12px',
      border: '1px solid #475569',
      borderRadius: '8px',
      fontSize: '1rem',
      transition: 'border-color 0.3s ease',
      background: '#1e293b',
      color: '#f1f5f9'
    },
    textarea: {
      padding: '12px',
      border: '1px solid #475569',
      borderRadius: '8px',
      fontSize: '1rem',
      resize: 'vertical',
      minHeight: '100px',
      fontFamily: 'inherit',
      background: '#1e293b',
      color: '#f1f5f9'
    },
    select: {
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid #475569',
      background: '#1e293b',
      color: '#f1f5f9',
      fontSize: '1rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23f1f5f9' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 15px center',
      backgroundSize: '16px',
      paddingRight: '45px'
    },
    option: {
      background: 'white',
      color: '#495057',
      padding: '10px'
    },
    required: {
      color: '#e74c3c',
      fontSize: '0.9rem'
    },
    section: {
      marginBottom: '30px',
      padding: '24px',
      background: '#1e293b',
      borderRadius: '12px',
      border: '1px solid #334155',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
    },
    sectionTitle: {
      fontSize: '1.3rem',
      color: '#f1f5f9',
      marginBottom: '24px',
      fontWeight: '600',
      borderBottom: '2px solid #3b82f6',
      paddingBottom: '12px',
      letterSpacing: '-0.02em'
    },
    specialtiesContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    },
    specialtiesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '12px',
      maxHeight: '200px',
      overflowY: 'auto',
      padding: '12px',
      border: '1px solid #334155',
      borderRadius: '8px',
      background: '#0f172a'
    },
    specialtyChip: {
      padding: '8px 12px',
      background: '#1e293b',
      border: '1px solid #475569',
      borderRadius: '20px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontSize: '0.9rem',
      textAlign: 'center',
      position: 'relative',
      userSelect: 'none',
      color: '#f1f5f9'
    },
    specialtyChipSelected: {
      background: '#3b82f6',
      color: 'white',
      border: '2px solid #3b82f6',
      transform: 'scale(1.02)'
    },
    checkmark: {
      position: 'absolute',
      right: '8px',
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: '0.8rem',
      fontWeight: 'bold'
    },
    selectedSpecialties: {
      padding: '10px',
      background: '#1e293b',
      borderRadius: '8px',
      color: '#f1f5f9',
      fontSize: '0.9rem'
    },
    pricingInfo: {
      background: '#1e293b',
      border: '1px solid #475569',
      borderRadius: '8px',
      padding: '15px',
      marginTop: '20px'
    },
    pricingTitle: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#fbbf24',
      marginBottom: '8px'
    },
    pricingText: {
      fontSize: '0.9rem',
      color: '#cbd5e1',
      lineHeight: '1.5'
    },
    toggleContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px'
    },
    toggleLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      cursor: 'pointer',
      userSelect: 'none'
    },
    toggleInput: {
      display: 'none'
    },
    toggleSlider: {
      position: 'relative',
      width: '60px',
      height: '30px',
      background: '#ccc',
      borderRadius: '30px',
      transition: 'all 0.3s ease',
      cursor: 'pointer'
    },
    toggleSliderActive: {
      background: '#27ae60'
    },
    toggleSliderDisabled: {
      opacity: 0.6,
      cursor: 'not-allowed'
    },
    toggleSliderThumb: {
      position: 'absolute',
      top: '3px',
      left: '3px',
      width: '24px',
      height: '24px',
      background: 'white',
      borderRadius: '50%',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    },
    toggleText: {
      fontSize: '1rem',
      fontWeight: '500',
      color: '#f1f5f9',
      minWidth: '150px'
    },
    requestsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: '16px',
      maxHeight: '600px',
      overflowY: 'auto',
      paddingRight: '8px',
      marginTop: '20px'
    },
    requestCard: {
      background: '#334155',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #475569',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
      transition: 'all 0.2s ease',
      position: 'relative',
      minHeight: '280px',
      display: 'flex',
      flexDirection: 'column'
    },
    requestHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '12px'
    },
    requestNumber: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#3b82f6'
    },
    requestTime: {
      fontSize: '0.75rem',
      color: '#94a3b8',
      fontWeight: '500'
    },
    requestStatusBadge: {
      marginBottom: '12px'
    },
    statusBadgeSmall: {
      padding: '4px 10px',
      borderRadius: '12px',
      fontSize: '0.75rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    requestInfo: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    requestClient: {
      fontSize: '1rem',
      color: '#f1f5f9',
      marginBottom: '8px'
    },
    requestPet: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    requestPetName: {
      fontSize: '0.875rem',
      color: '#cbd5e1',
      fontWeight: '500'
    },
    requestPetDetails: {
      fontSize: '0.75rem',
      color: '#94a3b8',
      fontStyle: 'italic'
    },
    requestExplanation: {
      fontSize: '0.75rem',
      color: '#94a3b8',
      marginTop: '8px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 3,
      WebkitBoxOrient: 'vertical'
    },
    requestActions: {
      display: 'flex',
      gap: '8px',
      marginTop: '12px',
      flexWrap: 'wrap'
    },
    acceptButtonSmall: {
      background: '#22c55e',
      color: 'white',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.875rem',
      fontWeight: '500',
      flex: 1
    },
    declineButtonSmall: {
      background: '#ef4444',
      color: 'white',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.875rem',
      fontWeight: '500',
      flex: 1
    },
    joinButtonSmall: {
      background: '#3b82f6',
      color: 'white',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.875rem',
      fontWeight: '500',
      flex: 1
    },
    statusTextSmall: {
      color: '#64748b',
      fontSize: '0.75rem',
      fontStyle: 'italic',
      padding: '8px 16px'
    },
    deliverablesButton: {
      padding: '8px 16px',
      background: '#3b82f6',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '500',
      transition: 'background 0.2s'
    },
    deliverablesForm: {
      marginTop: '20px',
      padding: '20px',
      background: '#1e293b',
      border: '1px solid #334155',
      borderRadius: '8px'
    },
    deliverablesFormTitle: {
      fontSize: '1.1rem',
      fontWeight: '600',
      color: '#f1f5f9',
      marginBottom: '20px'
    },
    deliverablesFormField: {
      marginBottom: '20px'
    },
    deliverablesLabel: {
      display: 'block',
      fontSize: '0.9rem',
      fontWeight: '500',
      color: '#cbd5e1',
      marginBottom: '8px'
    },
    deliverablesTextareaScrollable: {
      width: '100%',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid #475569',
      background: '#0f172a',
      color: '#f1f5f9',
      fontSize: '0.9rem',
      fontFamily: 'inherit',
      resize: 'vertical',
      maxHeight: '300px',
      overflowY: 'auto'
    },
    deliverablesTextarea: {
      width: '100%',
      padding: '12px',
      background: '#0f172a',
      border: '1px solid #334155',
      borderRadius: '6px',
      color: '#f1f5f9',
      fontSize: '0.9rem',
      fontFamily: 'inherit',
      resize: 'vertical',
      minHeight: '100px'
    },
    checklistItemRow: {
      display: 'flex',
      gap: '8px',
      marginBottom: '10px',
      alignItems: 'center'
    },
    checklistItemTextarea: {
      flex: 1,
      padding: '10px',
      borderRadius: '6px',
      border: '1px solid #475569',
      background: '#0f172a',
      color: '#f1f5f9',
      fontSize: '0.9rem',
      fontFamily: 'inherit',
      resize: 'vertical',
      minHeight: '40px',
      overflowY: 'auto'
    },
    checklistItemInput: {
      flex: 1,
      padding: '10px',
      background: '#0f172a',
      border: '1px solid #334155',
      borderRadius: '6px',
      color: '#f1f5f9',
      fontSize: '0.9rem'
    },
    removeChecklistButton: {
      padding: '10px 15px',
      background: '#ef4444',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '1.2rem',
      fontWeight: 'bold',
      lineHeight: '1'
    },
    addChecklistButton: {
      padding: '10px 16px',
      background: '#334155',
      color: '#f1f5f9',
      border: '1px solid #475569',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '500'
    },
    deliverablesFormActions: {
      display: 'flex',
      gap: '12px',
      justifyContent: 'flex-end',
      marginTop: '20px'
    },
    saveDeliverablesButton: {
      padding: '10px 20px',
      background: '#10b981',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '500',
      transition: 'background 0.2s'
    },
    cancelDeliverablesButton: {
      padding: '10px 20px',
      background: '#475569',
      color: '#f1f5f9',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '500'
    },
    deliverablesModalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    deliverablesModalContent: {
      background: '#1e293b',
      borderRadius: '12px',
      width: '100%',
      maxWidth: '700px',
      maxHeight: '90vh',
      overflow: 'auto',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
      border: '1px solid #334155'
    },
    deliverablesModalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px 25px',
      borderBottom: '1px solid #334155',
      background: '#1e293b'
    },
    deliverablesModalTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: '#f1f5f9',
      margin: 0
    },
    deliverablesModalCloseButton: {
      background: 'transparent',
      border: 'none',
      fontSize: '2rem',
      color: '#94a3b8',
      cursor: 'pointer',
      lineHeight: 1,
      padding: 0,
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '4px',
      transition: 'all 0.2s ease'
    },
    deliverablesModalBody: {
      padding: '25px',
      background: '#1e293b'
    },
    deliverablesModalFooter: {
      padding: '20px 25px',
      borderTop: '1px solid #334155',
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '12px',
      background: '#1e293b'
    },
    requestsTable: {
      background: 'white',
      borderRadius: '10px',
      overflow: 'hidden',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
      marginTop: '20px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.9rem'
    },
    tableHeader: {
      background: '#f8f9fa',
      borderBottom: '2px solid #e9ecef'
    },
    tableHeaderCell: {
      padding: '15px 12px',
      textAlign: 'left',
      fontWeight: '600',
      color: '#495057',
      borderBottom: '1px solid #e9ecef'
    },
    tableRow: {
      borderBottom: '1px solid #e9ecef',
      transition: 'background-color 0.2s ease'
    },
    tableCell: {
      padding: '12px',
      verticalAlign: 'middle',
      color: '#495057'
    },
    statusBadge: {
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '0.8rem',
      fontWeight: '500',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    statusPending: {
      background: '#fff3cd',
      color: '#856404',
      border: '1px solid #ffeaa7'
    },
    statusAccepted: {
      background: '#d4edda',
      color: '#155724',
      border: '1px solid #c3e6cb'
    },
    statusDeclined: {
      background: '#f8d7da',
      color: '#721c24',
      border: '1px solid #f5c6cb'
    },
    statusCancelled: {
      background: '#e2e3e5',
      color: '#383d41',
      border: '1px solid #d6d8db'
    },
    statusDefault: {
      background: '#e9ecef',
      color: '#495057',
      border: '1px solid #dee2e6'
    },
    actionButtons: {
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap'
    },
    statusText: {
      color: '#6c757d',
      fontSize: '0.8rem',
      fontStyle: 'italic'
    },
    petInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    petName: {
      fontWeight: '600',
      color: '#2d3748',
      fontSize: '0.9rem'
    },
    petDetails: {
      color: '#718096',
      fontSize: '0.8rem',
      fontStyle: 'italic'
    },
    explanationText: {
      maxWidth: '300px',
      wordWrap: 'break-word',
      lineHeight: '1.4',
      fontSize: '0.9rem',
      color: '#4a5568'
    },
    editActions: {
      display: 'flex',
      gap: '15px',
      marginTop: '20px'
    },
    saveButton: {
      background: 'linear-gradient(45deg, #27ae60, #2ecc71)',
      color: 'white',
      border: 'none',
      padding: '12px 24px',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '1rem',
      fontWeight: '500',
      transition: 'all 0.3s ease'
    },
    cancelButton: {
      background: 'transparent',
      color: '#6c757d',
      border: '2px solid #6c757d',
      padding: '10px 24px',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '1rem',
      fontWeight: '500',
      transition: 'all 0.3s ease'
    },
    requestsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    acceptButton: {
      background: 'linear-gradient(45deg, #27ae60, #2ecc71)',
      color: 'white',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '500'
    },
    joinButton: {
      background: 'linear-gradient(45deg, #3498db, #2980b9)',
      color: 'white',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '500'
    },
    declineButton: {
      background: 'transparent',
      color: '#e74c3c',
      border: '2px solid #e74c3c',
      padding: '6px 16px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '500'
    },
    historyContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    historyCard: {
      background: '#334155',
      borderRadius: '8px',
      padding: '15px 20px',
      border: '1px solid #475569',
      marginBottom: '12px',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
    },
    historyCardContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      width: '100%'
    },
    historyCardLeft: {
      minWidth: '150px'
    },
    historyCardTitle: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#f1f5f9',
      marginBottom: '4px'
    },
    historyCardDate: {
      fontSize: '0.85rem',
      color: '#94a3b8'
    },
    historyCardInfoRow: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '0',
      fontSize: '0.9rem'
    },
    historyCardLabel: {
      fontSize: '0.9rem',
      color: '#94a3b8',
      fontWeight: '500'
    },
    historyCardValue: {
      fontSize: '0.9rem',
      color: '#f1f5f9',
      fontWeight: '500'
    },
    historyCardSpacer: {
      color: '#475569',
      margin: '0 8px'
    },
    historyInfo: {
      flex: 1
    },
    historyTitle: {
      fontSize: '1.2rem',
      color: '#f1f5f9',
      margin: '0 0 10px 0'
    },
    historyDetails: {
      color: '#cbd5e1',
      margin: '0 0 5px 0'
    },
    historyTime: {
      color: '#94a3b8',
      fontSize: '0.9rem',
      margin: 0
    },
    historyActions: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      alignItems: 'flex-end'
    },
    historyStatus: {
      background: '#10b981',
      color: '#ffffff',
      padding: '6px 12px',
      borderRadius: '6px',
      fontSize: '0.85rem',
      fontWeight: '500'
    },
    emptyState: {
      textAlign: 'center',
      padding: '60px 20px',
      color: '#cbd5e1'
    },
    emptyIcon: {
      fontSize: '4rem',
      marginBottom: '20px',
      color: '#64748b'
    },
    emptyTitle: {
      fontSize: '1.5rem',
      color: '#f1f5f9',
      margin: '0 0 10px 0'
    },
    emptyText: {
      fontSize: '1rem',
      margin: 0,
      color: '#cbd5e1'
    },
    error: {
      background: '#f8d7da',
      color: '#721c24',
      padding: '15px',
      borderRadius: '8px',
      marginBottom: '20px',
      border: '1px solid #f5c6cb'
    }
  };

  if (loading && !trainerProfile) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.headerContent}>
            <div style={styles.logo}>
              <img 
                src="/images/logo.png" 
                alt="Pheefee Logo" 
                style={{...styles.logoIcon, width: '40px', height: '40px', objectFit: 'contain'}}
              />
              <span style={styles.logoText}>Trainer Portal</span>
            </div>
          </div>
        </div>
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
          <div style={{ fontSize: '2rem', marginBottom: '20px' }}>⏳</div>
          <p style={{ color: '#4a5568', fontSize: '1.1rem' }}>Loading trainer profile...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Error Display */}
      {error && (
        <div style={styles.error}>
          {error}
          <button
            onClick={() => setError(null)}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#721c24',
              marginLeft: '15px',
              cursor: 'pointer',
              fontSize: '1.2rem'
            }}
          >
            ×
          </button>
        </div>
      )}

      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.logo}>
            <button
              onClick={() => onBackToHome && onBackToHome()}
              style={styles.backButton}
            >
              ← Back to Home
            </button>
            <div style={{ borderLeft: '1px solid rgba(255,255,255,0.3)', height: '30px' }}></div>
            <img 
              src="/images/logo.png" 
              alt="Pheefee Logo" 
              style={{...styles.logoIcon, width: '40px', height: '40px', objectFit: 'contain'}}
            />
            <span style={styles.logoText}>Trainer Portal</span>
          </div>
          {isLoggedIn && onLogout && (
            <button onClick={onLogout} style={styles.logoutButton}>
              Logout
            </button>
          )}
        </div>
      </header>

      {/* Top Navigation Tabs */}
      <div style={styles.topNavBar}>
        <div style={styles.horizontalTabList}>
          <button
            onClick={() => handleTabChange('requests')}
            style={{
              ...styles.horizontalTabButton,
              ...(activeTab === 'requests' ? styles.activeHorizontalTabButton : {})
            }}
          >
            Active Requests
          </button>
          <button
            onClick={() => handleTabChange('history')}
            style={{
              ...styles.horizontalTabButton,
              ...(activeTab === 'history' ? styles.activeHorizontalTabButton : {})
            }}
          >
            Session History
          </button>
          <button
            onClick={() => handleTabChange('profile')}
            style={{
              ...styles.horizontalTabButton,
              ...(activeTab === 'profile' ? styles.activeHorizontalTabButton : {})
            }}
          >
            My Profile
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={styles.mainContent}>
        {/* Content Area */}
        <div style={styles.contentArea}>
          {activeTab === 'requests' && renderRequestsTab()}
          {activeTab === 'history' && renderHistoryTab()}
          {activeTab === 'profile' && renderProfileTab()}
        </div>
      </div>
    </div>
  );
}

export default TrainerPortal;
